export interface Movie {
  id: number;
  title: string;
  coverImage: string;
  rating: number;
  year: number;
  category: string;
  categorySlug: string;
  duration: string;
  description: string;
  director: string;
  actors: string[];
  region: string;
  type: string;
  tags: string[];
  isNew: boolean;
  isHot: boolean;
  updateEpisode: string;
  totalEpisodes: number;
}

export const categories = [
  { name: '全部', slug: 'all' },
  { name: '电影', slug: 'movie' },
  { name: '电视剧', slug: 'tv-series' },
  { name: '综艺', slug: 'variety' },
  { name: '动漫', slug: 'anime' },
  { name: '纪录片', slug: 'documentary' },
];

export const movies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    coverImage: 'https://readdy.ai/api/search-image?query=Futuristic%20Chinese%20sci-fi%20movie%20poster%20with%20astronauts%20and%20massive%20space%20station%2C%20dramatic%20lighting%2C%20cinematic%20composition%2C%20dark%20space%20background%20with%20stars%2C%20epic%20scale%2C%20movie%20poster%20design%20style%20with%20Chinese%20title%20area&width=400&height=560&seq=movie-001&orientation=portrait',
    rating: 8.6,
    year: 2025,
    category: '电影',
    categorySlug: 'movie',
    duration: '148分钟',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。面对未知的旅程，一群勇敢的年轻人挺身而出，展开了一场跨越时空的冒险。本片延续前作的宏大叙事，讲述人类在危机面前团结一心的感人故事，视觉效果震撼，情感真挚动人，是中国科幻电影的又一里程碑之作。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢', '宁理'],
    region: '中国大陆',
    type: '科幻 / 冒险 / 灾难',
    tags: ['科幻', '冒险', 'IMAX', '热门推荐'],
    isNew: true,
    isHot: true,
    updateEpisode: 'HD',
    totalEpisodes: 1,
  },
  {
    id: 2,
    title: '繁花',
    coverImage: 'https://readdy.ai/api/search-image?query=Wong%20Kar-wai%20style%20Chinese%20drama%20poster%2C%201990s%20Shanghai%20aesthetic%2C%20neon%20lights%2C%20elegant%20woman%20in%20qipao%2C%20vintage%20atmosphere%2C%20cinematic%20glow%2C%20nostalgic%20mood%2C%20rich%20warm%20tones&width=400&height=560&seq=movie-002&orientation=portrait',
    rating: 9.3,
    year: 2024,
    category: '电视剧',
    categorySlug: 'tv-series',
    duration: '30集',
    description: '九十年代的上海，机遇与挑战并存。阿宝凭借自己的智慧和勇气，在商海中摸爬滚打，从默默无闻到叱咤风云。在这座城市里，他遇到了形形色色的人物，经历了跌宕起伏的人生。这部由王家卫执导的年代大剧，以独特的视觉语言和细腻的叙事，展现了上海的城市变迁与人情冷暖。',
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣', '辛芷蕾', '游本昌'],
    region: '中国大陆',
    type: '剧情 / 年代',
    tags: ['年代剧', '经典', '高分推荐', '沪上风情'],
    isNew: false,
    isHot: true,
    updateEpisode: '全30集',
    totalEpisodes: 30,
  },
  {
    id: 3,
    title: '封神第二部',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20movie%20poster%2C%20ancient%20Chinese%20mythology%2C%20warriors%20in%20ancient%20armor%2C%20mythical%20beasts%2C%20dramatic%20battle%20scene%2C%20golden%20and%20red%20tones%2C%20cinematic%20epic%20scale&width=400&height=560&seq=movie-003&orientation=portrait',
    rating: 8.4,
    year: 2025,
    category: '电影',
    categorySlug: 'movie',
    duration: '156分钟',
    description: '殷商末年，纣王暴虐无道，天下大乱。姜子牙率领众仙下山辅佐武王伐纣，一场神魔大战即将拉开序幕。本片延续第一部宏大的世界观，以更震撼的特效和更深邃的人物刻画，展现了中国古典神话的壮丽画卷。每一位角色都有着复杂的人性与命运抉择，让人在视觉享受之余也能感受到深刻的情感共鸣。',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适', '陈牧驰'],
    region: '中国大陆',
    type: '奇幻 / 动作 / 史诗',
    tags: ['奇幻', '神话', 'IMAX', '票房冠军'],
    isNew: true,
    isHot: true,
    updateEpisode: 'HD',
    totalEpisodes: 1,
  },
  {
    id: 4,
    title: '漫长的季节',
    coverImage: 'https://readdy.ai/api/search-image?query=Northeast%20China%20small%20town%20drama%20poster%2C%20autumn%20landscape%2C%20old%20factory%20background%2C%20mysterious%20and%20nostalgic%20mood%2C%20warm%20amber%20tones%2C%20Chinese%20suspense%20thriller%20aesthetic&width=400&height=560&seq=movie-004&orientation=portrait',
    rating: 9.4,
    year: 2024,
    category: '电视剧',
    categorySlug: 'tv-series',
    duration: '12集',
    description: '一座东北小城，一桩尘封多年的悬案。出租车司机王响在寻找真相的过程中，揭开了一段跨越二十年的往事。故事以细腻的笔触描绘了普通人的命运沉浮，在悬疑的外壳下藏着对时代、人性与生活的深刻思考。每个角色都有血有肉，每段对白都耐人寻味，是近年来不可多得的国产剧佳作。',
    director: '辛爽',
    actors: ['范伟', '秦昊', '陈明昊', '李庚希', '刘琳'],
    region: '中国大陆',
    type: '悬疑 / 剧情 / 犯罪',
    tags: ['悬疑', '高分神剧', '口碑爆款', '必看'],
    isNew: false,
    isHot: true,
    updateEpisode: '全12集',
    totalEpisodes: 12,
  },
  {
    id: 5,
    title: '哪吒之魔童闹海',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20movie%20poster%2C%20mythical%20boy%20warrior%20with%20flaming%20spear%2C%20vibrant%20red%20and%20gold%20colors%2C%20dynamic%20action%20pose%2C%20traditional%20Chinese%20art%20style%20blended%20with%20modern%203D%2C%20epic%20fantasy%20atmosphere&width=400&height=560&seq=movie-005&orientation=portrait',
    rating: 9.1,
    year: 2025,
    category: '动漫',
    categorySlug: 'anime',
    duration: '120分钟',
    description: '天劫之后，哪吒和敖丙的灵魂虽保住了，但肉身危在旦夕。太乙真人打算用七色宝莲为二人重塑肉身，但在此过程中却遭遇了重重阻碍。哪吒必须面对更强大的敌人和更艰难的抉择。本片延续前作的高水准制作，画面更加精美，故事更加动人，笑点与泪点并存，适合全年龄段观众观看。',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨', '陈浩', '绿绮'],
    region: '中国大陆',
    type: '动画 / 奇幻 / 冒险',
    tags: ['动画', '神话', '国产动画', '合家欢'],
    isNew: true,
    isHot: true,
    updateEpisode: 'HD',
    totalEpisodes: 1,
  },
  {
    id: 6,
    title: '庆余年第二季',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20poster%2C%20ancient%20Chinese%20palace%20setting%2C%20elegant%20warrior%20scholar%20character%2C%20ink%20wash%20painting%20style%2C%20mysterious%20atmosphere%2C%20golden%20and%20dark%20green%20tones&width=400&height=560&seq=movie-006&orientation=portrait',
    rating: 8.9,
    year: 2025,
    category: '电视剧',
    categorySlug: 'tv-series',
    duration: '36集',
    description: '范闲从北齐归来后，面对更加复杂的朝堂局势和各方势力的暗流涌动。为了保护身边的人，他必须在权谋与正义之间做出选择。本季剧情更加紧凑，人物关系更加错综复杂，动作场面更加精彩。延续第一季的幽默风格与深刻主题，是年度最受期待的国产古装大剧之一。',
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明', '吴刚', '郭麒麟'],
    region: '中国大陆',
    type: '古装 / 权谋 / 喜剧',
    tags: ['古装', '权谋', '热门IP', '必追'],
    isNew: true,
    isHot: true,
    updateEpisode: '更新至36集',
    totalEpisodes: 36,
  },
  {
    id: 7,
    title: '孤注一掷',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20movie%20poster%2C%20dark%20and%20tense%20atmosphere%2C%20red%20warning%20tones%2C%20technological%20elements%2C%20mysterious%20phone%20screens%2C%20cybercrime%20theme%2C%20suspenseful%20cinematic%20lighting&width=400&height=560&seq=movie-007&orientation=portrait',
    rating: 8.7,
    year: 2024,
    category: '电影',
    categorySlug: 'movie',
    duration: '130分钟',
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外陷入境外诈骗工厂的陷阱。在经历了种种非人遭遇后，他们决定联手反击。本片改编自上万起真实诈骗案例，以极具冲击力的手法揭露了网络诈骗的黑暗内幕，让人看后不禁倒吸一口凉气。这不仅是一部电影，更是一记警钟。',
    director: '申奥',
    actors: ['张艺兴', '金晨', '咏梅', '王传君', '王大陆'],
    region: '中国大陆',
    type: '犯罪 / 剧情 / 悬疑',
    tags: ['犯罪', '现实题材', '高能预警', '口碑佳作'],
    isNew: false,
    isHot: true,
    updateEpisode: 'HD',
    totalEpisodes: 1,
  },
  {
    id: 8,
    title: '乘风破浪的姐姐',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20poster%2C%20group%20of%20elegant%20female%20celebrities%20on%20stage%2C%20glamorous%20styling%2C%20sparkling%20lights%2C%20music%20performance%20theme%2C%20vibrant%20pink%20and%20purple%20tones%2C%20entertainment%20show%20aesthetic&width=400&height=560&seq=movie-008&orientation=portrait',
    rating: 8.2,
    year: 2025,
    category: '综艺',
    categorySlug: 'variety',
    duration: '12期',
    description: '来自不同领域的姐姐们再次集结，在舞台上挥洒汗水、突破自我。她们用实力证明年龄只是数字，梦想永远不晚。本季节目在赛制上全面升级，舞台效果更加震撼，姐姐们的表现也更加精彩。每一期都有令人惊喜的舞台表演和感人的幕后故事，是夏日不可错过的综艺盛宴。',
    director: '吴梦知',
    actors: ['宁静', '那英', '王心凌', '于文文', '郑秀妍'],
    region: '中国大陆',
    type: '音乐 / 真人秀 / 竞演',
    tags: ['综艺', '音乐', '女性力量', '热门综艺'],
    isNew: true,
    isHot: false,
    updateEpisode: '更新至08期',
    totalEpisodes: 12,
  },
  {
    id: 9,
    title: '深海',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20poster%2C%20magical%20underwater%20world%2C%20colorful%20marine%20life%2C%20dreamlike%20ink%20wash%20art%20style%2C%20girl%20exploring%20deep%20ocean%2C%20ethereal%20blue%20and%20gold%20lighting%2C%20surreal%20atmosphere&width=400&height=560&seq=movie-009&orientation=portrait',
    rating: 8.8,
    year: 2024,
    category: '动漫',
    categorySlug: 'anime',
    duration: '112分钟',
    description: '小女孩参宿意外坠入神秘的海底世界，在这里她遇到了形形色色的海洋生物，开启了一段关于成长与自我发现的奇幻旅程。本片以惊艳的水墨粒子特效打造了一个前所未有的视觉奇观，色彩斑斓的画面仿佛流动的油画。故事温暖治愈，探讨了孤独、勇气与爱的主题，触动每一位观众的心。',
    director: '田晓鹏',
    actors: ['苏鑫', '王亭文', '滕奎兴', '杨婷', '吉静'],
    region: '中国大陆',
    type: '动画 / 奇幻 / 治愈',
    tags: ['动画', '治愈', '视觉盛宴', '国漫之光'],
    isNew: false,
    isHot: false,
    updateEpisode: 'HD',
    totalEpisodes: 1,
  },
  {
    id: 10,
    title: '地球脉动第三季',
    coverImage: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20poster%2C%20stunning%20wildlife%20photography%2C%20diverse%20animals%20in%20natural%20habitats%2C%20breathtaking%20landscapes%2C%20planet%20earth%20theme%2C%20vibrant%20natural%20colors%2C%20cinematic%20wildlife%20portrait&width=400&height=560&seq=movie-010&orientation=portrait',
    rating: 9.7,
    year: 2024,
    category: '纪录片',
    categorySlug: 'documentary',
    duration: '8集',
    description: '从冰封的极地到炎热的沙漠，从深邃的海洋到高耸的山脉，这部史诗级纪录片以全新拍摄技术捕捉地球生命的壮丽与奇迹。每一帧画面都是壁纸级别的视觉享受，每一个故事都令人叹为观止。本季聚焦人类活动对自然界的影响，在展示自然之美的同时也引发人们对环境保护的深刻思考。',
    director: 'BBC Studios',
    actors: ['大卫·爱登堡'],
    region: '英国',
    type: '自然 / 纪录片',
    tags: ['纪录片', '自然', 'BBC', '高分经典'],
    isNew: false,
    isHot: false,
    updateEpisode: '全8集',
    totalEpisodes: 8,
  },
  {
    id: 11,
    title: '热辣滚烫',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20drama%20movie%20poster%2C%20boxing%20ring%20theme%2C%20inspirational%20weight%20loss%20story%2C%20warm%20lighting%2C%20sports%20and%20determination%2C%20vibrant%20orange%20and%20red%20tones%2C%20motivational%20atmosphere&width=400&height=560&seq=movie-011&orientation=portrait',
    rating: 8.1,
    year: 2024,
    category: '电影',
    categorySlug: 'movie',
    duration: '129分钟',
    description: '乐莹是一个善良但有些自卑的女孩，在经历了人生的低谷后，她决定通过拳击改变自己。从零基础到站上擂台，她用汗水和坚持证明了自己的价值。这不仅是一个关于减肥的故事，更是一个关于自我认同和勇敢追梦的故事。笑中带泪，温暖人心，献给每一个努力生活的普通人。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐', '杨紫', '沙溢'],
    region: '中国大陆',
    type: '喜剧 / 剧情 / 运动',
    tags: ['喜剧', '励志', '春节档', '票房冠军'],
    isNew: false,
    isHot: false,
    updateEpisode: 'HD',
    totalEpisodes: 1,
  },
  {
    id: 12,
    title: '三体',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%2C%20cosmic%20theme%2C%20three%20body%20problem%20concept%2C%20mysterious%20alien%20civilization%2C%20dark%20space%20background%2C%20futuristic%20technology%2C%20enigmatic%20and%20grand%20scale&width=400&height=560&seq=movie-012&orientation=portrait',
    rating: 8.5,
    year: 2024,
    category: '电视剧',
    categorySlug: 'tv-series',
    duration: '30集',
    description: '科学界接连发生异常事件，纳米科学家汪淼在警官史强的协助下，逐渐揭开了一个地外文明的秘密。当人类得知三体文明的存在后，一场跨越光年的博弈开始了。本剧忠实还原刘慈欣原著的宏大想象，以精良的特效和扎实的剧情，将中国科幻电视剧的水准推向了新的高度。',
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    region: '中国大陆',
    type: '科幻 / 悬疑 / 剧情',
    tags: ['科幻', '刘慈欣', 'IP改编', '国产科幻'],
    isNew: false,
    isHot: true,
    updateEpisode: '全30集',
    totalEpisodes: 30,
  },
];

export const featuredMovies = movies.filter(m => m.isHot).slice(0, 6);

export const newReleases = movies.filter(m => m.isNew);

export const topRated = [...movies].sort((a, b) => b.rating - a.rating).slice(0, 8);